export class UrlHelper {
    /**
     * Contract ID (CID) regular expression
     */
    private static contractIdRegexp = /\D([0-9]{10})(\D|$)/i; // restricting the CID match to 10 numbers only
    private static memberIdRegexp = /\D([1-9][0-9]{17}[0-9]?)(\D|$)?/i; // restricting the CID match to 10 numbers only
    private static securityContractIdRegexp = /(MP[A-Z0-9]{10})(\D|$)/i;

    public static matchCidInPath(wholeUrl: string) {
        const urlPath = wholeUrl.split('?')?.[0] ?? wholeUrl;
        return UrlHelper.matchCid(urlPath);
    }

    public static matchMidInPath(wholeUrl: string) {
        const urlPath = wholeUrl.split('?')?.[0] ?? wholeUrl;
        return UrlHelper.matchMid(urlPath);
    }

    /**
     * Performs CID regex match on given url
     * @param {string} url
     * @returns {string[]}
     */
    public static matchCid(url: string): string[] {
        return url.match(UrlHelper.contractIdRegexp);
    }

    /**
     * Performs CID regex match on given url
     * @param {string} url
     * @returns {string[]}
     */
    public static matchMid(url: string): string[] {
        return url.match(UrlHelper.memberIdRegexp);
    }

    /**
     * Performs CID regex match on given url
     * @param {string} url
     * @returns {string[]}
     */
    public static matchSecurityCid(url: string): string[] {
        return url.match(UrlHelper.securityContractIdRegexp);
    }

    /**
     * Extracts cid on given url
     * @param {string} url
     * @returns {string}
     */
    public static getCidFromUrl(url: string): string {
        const match: string[] = url.match(UrlHelper.contractIdRegexp);
        // return second match (second match has cid only, first match has cid + `/` character arround it)
        return match && match.length > 1 ? match[1] : null;
    }

    /**
     * Checks if provided url is external
     * @param {string} url
     * @returns {boolean}
     */
    public static isExternalUrl(url: string): boolean {
        return url.indexOf('//') !== -1;
    }
}
